import { Typography } from "@mui/material";
import "../../../assets/styles/components/BlurredTypograhy.scss";

interface Props {
  className?: string;
  defaulValue?: string; // The optional default value to display
}

/**
 * BlurredTypograhy is a React component which is responsible for displaying a blurred or
 * obscured string of characters, intended to mask sensitive information.
 */
function BlurredTypograhy({ className, defaulValue }: Readonly<Props>) {

  const displayText = defaulValue ?? "Mustermann Max";

  return (
    <div className="flex-wrap align-center">
      <Typography className={`blurryText ${className}`}>
        {displayText}
      </Typography>
      <div className="icon icon-lock"></div>
    </div>
  );
}

export default BlurredTypograhy;
